<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                
                <div class="card">
                    <div class="card-header card-header-icon card-header-rose">
                        <div class="card-icon">
                            <i class="material-icons">add</i>
                        </div>
                        <h4 class="card-title ">Novo</h4>
                    </div>

                    <b-form @submit="onSubmit" novalidate="novalidate">
                        <div class="card-body">
                            <md-tabs class="md-primary">
                                <md-tab id="tab-home" md-label="Dados do Perfil" md-icon="add">
                                    <p>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group bmd-form-group"
                                                    v-bind:class="{'is-filled': form.name != '', 'has-danger' : validation.name != '' }">
                                                    <label for="name" class="bmd-label-floating">Nome *</label>
                                                    <input refs="name" type="text" class="form-control" v-model="form.name" />
                                                    <label v-if="validation.name != ''" id="name-error" class="error" for="name">{{ validation.name }}</label>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-12">
                                                <div class="form-group bmd-form-group"
                                                    v-bind:class="{'has-danger' : validation.type_profile_id != '' }">
                                                    <model-select :options="type_profiles"
                                                        v-model="form.type_profile_id"
                                                        placeholder="Tipo do Perfil">
                                                    </model-select>
                                                    <label v-if="validation.type_profile_id != ''" id="type_profile_id-error" class="error" for="type_profile_id">{{ validation.type_profile_id }}</label>
                                                </div>
                                            </div>
                                        </div>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <div class="form-group bmd-form-group is-filled">
                                                <label for="branches" class="bmd-label-floating">Lojas</label>
                                                <multi-select
                                                        v-model="form.branches"
                                                        :options="branches"
                                                        :multiple="true"
                                                        :clear-on-select="false"
                                                        :preserve-search="true"
                                                        placeholder="Selecione as lojas"
                                                        label="name"
                                                        track-by="name"
                                                        :disabled="form.visualization_all_branch"
                                                        value="id">
                                                </multi-select>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-md-12" >
                                            <div class="form-group bmd-form-group"
                                                 v-bind:class="{'has-danger' : validation.visualization_all_branch != '' }">
                                            <b-form-checkbox style="padding-left: 0; padding-top: 1rem;"
                                                             v-model="form.visualization_all_branch"
                                                             @change="clearBranches"
                                            >
                                                {{ 'Visualizar Todoas as Lojas' }}
                                            </b-form-checkbox>
                                            <label v-if="validation.visualization_all_branch != ''"
                                                   id="visualization_all_branch-error"
                                                   class="error" for="visualization_all_branch">{{ validation.visualization_all_branch }}</label>
                                            </div>
                                        </div>
                                    </div>
                                        <br />
                                        <hr />
                                        <div class="row">
                                            <div class="col-md-12" v-bind:class="{'has-danger' : validation.permissions != '' }">
                                                <div class="card-header">
                                                    <h4 class="card-title">Permissões</h4>
                                                </div>
                                                <div class="card-body">
                                                    <div class="table-responsive">
                                                        <table class="table">
                                                            <thead class="text-primary">
                                                                <tr>
                                                                    <th>
                                                                        <b-form-checkbox v-model="check.all" @change="toggleAll">
                                                                        Funcionalidades
                                                                        </b-form-checkbox>
                                                                    </th>
                                                                    <th class="text-center" v-for="(action, index) in actions">
                                                                        <b-form-checkbox v-model="check.cols[index]" @change="toggleCol(index)">
                                                                        {{ action.name }}
                                                                        </b-form-checkbox>
                                                                    </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(functionality, indexFunctionality) in form.functionalities">
                                                                <td>
                                                                    {{ functionality.name }}
                                                                </td>
                                                                <td class="text-center" v-for="(action, indexAction) in functionality.actions">
                                                                    <b-form-checkbox v-model="action.checked">
                                                                        {{ action.name }}
                                                                    </b-form-checkbox>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                                <br />
                                                <label v-if="validation.permissions != ''" id="permissions-error" class="error" for="permissions">{{ validation.permissions }}</label>
                                            </div>
                                        </div>
                                    </div>
                                    </p>
                                </md-tab>
                                <md-tab id="tab-pages" md-label="Cadastrar metas para o perfil" md-icon="pages">
                                    <goal-grid 
                                        gridTitle="Metas para o PERFIL"
                                        :items="form.goals"
                                        @add="addGoal"
                                        id="goal-grid"
                                    />
                                </md-tab>
                            </md-tabs>
                            
                    </div>
                    <div class="card-footer">
                        <form-buttons 
                            v-bind:to-back="{name: 'profiles.index'}"
                            text-back="Voltar"
                            icon-back="keyboard_arrow_left" />
                    </div>
                </b-form>
            </div>
        </div>
    </div>
</div>
</div>
</template>
<script>
    import ActionService from '@/services/modules/actions.service';
    import TypeProfileService from '@/services/modules/typeprofiles.service';
    import GoalGrid from '@/views/Goals/Grid';

    export default {
        components : {
            GoalGrid,
        },
        computed: {
             branches() {
                return this.$store.state.defaults.branches;
            },
        },
        data() {
            return {
                actions: [],
                check: {
                    all: false,
                    cols: [],
                    rows: []
                },
                form: {
                    name: '',
                    type_profile_id: '',
                    functionalities: [],
                    goals : [{}],
                    branches: [],
                    visualization_all_branch: true
                },
                type_profiles: [],
                items: [],
                validation: {
                    name: '',
                    type_profile_id: '',
                    permissions: '',
                    visualization_all_branch: ''
                }
            };
        },
        created() {
            var self = this;
            
            self.type_profiles = [];
            self.actions = [];
            self.items = [];
            
            self.getData();
        },
        methods: {
            clearBranches() {
                this.form.branches = []
            },
            checkItemChangeChecked(indexFunctionality, indexAction, status){
                this.form.functionalities[indexFunctionality].actions[indexAction].checked = status;
            },
            addGoal( item ){
                this.form.goals.push( item );
            },
            getData() {
                this.getDataFuncionalities();
            },
            async getDataFuncionalities() {
                var self = this;
                self.items = [];
                
                self.$root.$emit("onLoading");
                
                const functionality = self.$store.dispatch('functionalities/all');
                
                functionality.then(function(_response){
                    _response.map(function(_functionality, _indexFuncionality){
                        self.items.push(_functionality);
                    });
                    
                    self.$root.$emit("onLoading");
                    self.getDataBranches();
                    self.getDataActions();
                });
                
                functionality.catch(function(){
                    self.$root.$emit("onLoading");
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$router.push({"name" : "profiles.index"});
                });
            },
            async getDataActions() {
                var self = this;

                self.$root.$emit("onLoading");

                const action = ActionService.get();

                action.then(function (_list) {
                    self.actions = _list;

                    self.items.map(function (_functionality, _indexFunctionality) {
                        var functionality = _functionality;
                        functionality.actions = [];

                        _list.map(function (_action, _indexAction) {
                            var actionClone = Object.assign({}, _action);
                            delete actionClone.id;
                            actionClone.action_id = _action.id;
                            actionClone.id = _action.id + "-" + _functionality.id;
                            actionClone.checked = false;
                            functionality.actions.push(actionClone);
                        });

                        self.form.functionalities.push(functionality);
                    });
                    
                    self.$root.$emit("onLoading");
                    self.getDataTypeProfile();
                });
                
                action.catch(function(){
                    self.$root.$emit("onLoading");
                    self.$notify.error("Falha na comunicação com a API!");
                    self.$router.push({"name" : "profiles.index"});
                });
            },
            async getDataTypeProfile() {
                var self = this;
                
                self.$root.$emit("onLoading");
                
                const typeProfile = TypeProfileService.get();

                typeProfile.then(function (_list) {
                    var list = [];
                    self.$root.$emit("onLoading");

                    _list.map(function (object) {
                        list.push({
                            value: object.id,
                            text: object.name
                        });
                    });

                    self.type_profiles = list;
                });

                typeProfile.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },

            async getDataBranches() {
                var self = this;

                self.$root.$emit("onLoading");

                //self.getData();
                const response = self.$store.dispatch('branches/all');

                //
                response.then(function () {
                    self.$root.$emit("onLoading");

                });
                //
                response.catch(function () {
                    self.$root.$emit("onLoading");
                });
            },
             async getAllProfiles() {
                var self = this;

                self.$root.$emit('onLoading');

                const response = self.$store.dispatch('profiles/all');

                response.then(function () {
                    self.$root.$emit('onLoading');
                });

                response.catch(function () {
                    self.$root.$emit('onLoading');
                });
            },
            toggleCol(_col) {
                var self = this;
                var checked = !self.check.cols[_col];
                
                self.form.functionalities.map(function(_functionality, _indexFunctionality){
                    _functionality.actions[_col].checked = checked;
                });
            },
            toggleRow(_row) {
                var self = this;
                var checked = !self.check.rows[_row];
                var functionality = self.form.functionalities[_row];
                
                functionality.actions.map(function(_action, _indexAction){
                    functionality.actions[_indexAction].checked = checked;
                });
            },
            toggleAll() {
                var self = this;
                var checked = !self.check.all;
                
                self.form.functionalities.map(function(_functionality, _indexFunctionality){
                    self.check.rows[_indexFunctionality] = checked;
                    
                    _functionality.actions.map(function(_action, _indexAction){
                        self.check.cols[_indexAction] = checked;
                        
                        _functionality.actions[_indexAction].checked = checked;
                    });
                });
            },
            onSubmit(_ev) {
                var valid = true;
                var self = this;
                var permissions = [];
                self.form.functionalities.map(function(_functionality, _indexFunctionality){
                    _functionality.actions.map(function(_action, _indexAction){
                        if(_action.checked){
                            permissions.push({
                                functionality_id: _functionality.id,
                                action_id: _action.action_id
                            });
                        }
                    });
                });

                console.log(self.form.functionalities)

                self.validation.name = '';
                self.validation.type_profile_id = '';
                self.validation.permissions = '';
                self.validation.visualization_all_branch = '';

                if (self.form.name == '') {
                    self.validation.name = 'Campo obrigatório!';
                    valid = false;
                }

                if (self.form.type_profile_id == '') {
                    self.validation.type_profile_id = 'Campo obrigatório!';
                    valid = false;
                }
                if (!self.form.visualization_all_branch && !self.form.branches.length) {
                    self.validation.visualization_all_branch = 'Escolha todas as lojas ou alguma específica!';
                    valid = false;
                }
                
                if(permissions.length === 0){
                    self.validation.permissions = 'Escolha ao menos uma opção!';
                    valid = false;
                }

                this.form.permissions = permissions;

                if (valid) {
                    self.$root.$emit("onLoading");
                    const response = self.$store.dispatch('profiles/add', this.form);

                    response.then(function () {
                        self.$root.$emit("onLoading");
                        self.$notify.success("Perfil criado com sucesso!");
                        self.getAllProfiles();
                        self.$router.push({'name': 'profiles.index'});
                    });

                    response.catch(function (err) {
                        self.$root.$emit("onLoading");
                        if (err.status === 422) {
                            var data = err.data;

                            if (data.errors.name !== undefined) {
                                self.validation.name = data.errors.name[0];
                            }

                            if (data.errors.type_profile_id !== undefined) {
                                self.validation.type_profile_id = data.errors.type_profile_id[0];
                            }
                        }
                    });
                }

                _ev.preventDefault();
            }
        }
    };
</script>
<style scoped>
    .card-title {
        color: #3c4858;
        text-decoration: none;
    }
    #goal-grid{ margin-top: 100px;}
</style>